import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Chat Application built with Socket.io" link="https://gour-io-chatapp.herokuapp.com" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a chat application built with NodeJS, Sockets.io and it was awesome.
    </ProjectCard>
    <ProjectCard title="COVID-19 Corona Tracker" link="https://gour-io.github.io/corona-tracker" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a Corona Tracker application built with NodeJS, React.
    </ProjectCard>
    <ProjectCard title="Tindog website" link="https://gour-io.github.io/Tindog" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a tinDOG website built with HTML, CSS, Bootstrap.
    </ProjectCard>
    <ProjectCard title="Real Weather Website" link="https://gour-io-weather-app.herokuapp.com/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a WEATHER application built with NodeJS.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      